import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

import { SELECT_LOADING } from '~/constants/testIDs';

export const SelectLoadingOption = memo(() => {
  return (
    <li className="flex w-full items-center justify-start" data-testid={SELECT_LOADING}>
      <Spinner className="size-3 text-grey-12" />
      <div className="ml-1.5 font-medium text-14 text-grey-10">Loading</div>
    </li>
  );
});

SelectLoadingOption.displayName = 'SelectLoadingOption';
